import { useParams } from 'react-router-dom';
import useAuditProgress from './useAuditProgress';
import StageCard from './StageCard';
import '../../../styles/AuditProgress.css';

export default function AuditProgressPage() {
    const { client_id, building_id } = useParams();
    const { progress, loading, error } = useAuditProgress(building_id);

    if (loading) {
        return <div className="audit-progress-page-status">Chargement du suivi d'audit...</div>;
    }

    if (error || !progress) {
        return <div className="audit-progress-page-status">Impossible de charger le suivi d'audit{error ? ` : ${error}` : ''}.</div>;
    }

    const routeParams = { clientId: client_id, buildingId: building_id };
    const ringStyle = {
        background: `conic-gradient(#051b71 ${progress.global_percent * 3.6}deg, #e8eaf3 0deg)`,
    };

    // Met en avant, sur la timeline, la première étape qui n'est pas encore "ok"
    // (repère visuel de "où reprendre" pour l'auditeur).
    const firstOpenIssueKey = progress.stages.find(s => s.status !== 'ok' && s.status !== 'not_available')?.key;

    return (
        <div className="audit-progress-page">
            <div className="audit-progress-header">
                <div className="audit-progress-header-text">
                    <h1>Suivi de l'audit</h1>
                    <p>Progressez étape par étape jusqu'au chiffrage des solutions.</p>
                </div>
                <div className="audit-progress-header-metric">
                    {progress.warnings_count > 0 && (
                        <span className="audit-progress-header-warnings">⚠ {progress.warnings_count} point{progress.warnings_count > 1 ? 's' : ''} à traiter</span>
                    )}
                    <div className="audit-progress-ring" style={ringStyle}>
                        <span className="audit-progress-ring-value">{progress.global_percent}%</span>
                    </div>
                </div>
            </div>

            <div className="audit-timeline">
                {progress.stages.map(stage => (
                    <StageCard
                        key={stage.key}
                        stage={stage}
                        routeParams={routeParams}
                        isFirstOpenIssue={stage.key === firstOpenIssueKey}
                    />
                ))}
            </div>
        </div>
    );
}
